import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgStethoscope = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M56.877 34.194a8.527 8.527 0 1 0-11.307 8.052A12.65 12.65 0 0 1 33.3 52a12.58 12.58 0 0 1-12.565-12.6v-4.685c.25-.027.5-.044.748-.08l.189-.034a15.4 15.4 0 0 0 11.99-14.941V3H23.155v5h5.507v11.66a10.37 10.37 0 0 1-7.981 10.04 17.5 17.5 0 0 1-2.354.163 12 12 0 0 1-2.031-.147 10.36 10.36 0 0 1-8.173-10.06V8h5.336V3H3.123v16.659a15.386 15.386 0 0 0 12.139 14.948c.042.009.21.042.473.081V39.4A17.58 17.58 0 0 0 33.315 57a17.65 17.65 0 0 0 17.307-14.595 8.535 8.535 0 0 0 6.255-8.211m-8.527 3.527a3.527 3.527 0 1 1 3.527-3.527 3.53 3.53 0 0 1-3.527 3.527",
      fill: "currentColor"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStethoscope);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
